module.exports = __webpack_public_path__ + "static/img/mini4.e4d2ed1d.png";